import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { isNullOrUndefined } from "@pineapplelab/util";

export class AppErrorStateMatcher implements ErrorStateMatcher {

  constructor(
    private model: any,
    private field: string
  ) {}

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const hasErrorByField = isNullOrUndefined( this.model ) || isNullOrUndefined(this.model.__errorByField);
    const isUsed = (control.dirty || control.touched);
    return isUsed && (hasErrorByField || !isNullOrUndefined(this.model.__errorByField[this.field]));
  }

}
